'use client';

import { ContactSupport } from './ContactSupport';
import { useContactSupport as useContactSupportHook } from '@workspace/hooks/useContactSupport';
import { Spinner } from '@workspace/ui/common';
import { ContactSupportSectionProps } from './contact-support.types';

export function ContactSupportSection({ locator, isSkip = false, showError = false }: ContactSupportSectionProps) {
  const { enabled, data, loading, error } = useContactSupportHook(locator, {
    isSkip,
  });

  if (isSkip) return null;
  if (loading) return <Spinner size="small" className="text-primary" />;

  if (error) {
    return showError ? (
      <div className="text-primary-500 text-sm mt-4 max-w-full truncate">
        Error loading Contact Support: {String(error)}
      </div>
    ) : null;
  }

  if (!enabled || !data) return null;
  return <ContactSupport {...data} />;
}
